import * as React from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

import LoadingIndicator from './LoadingIndicator';

const containerStyle = {
    width: '100%',
    height: '100%'
    //height: '850px'
};

const center = {
    lat: 50.4508289,
    lng: 10.396404
};

var stylesArray = [
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#444444"
            }
        ]
    },
    {
        "featureType": "administrative.country",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#fecada"
            },
            {
                "lightness": "0"
            },
            {
                "gamma": "1"
            },
            {
                "weight": "3.00"
            }
        ]
    },
    {
        "featureType": "administrative.country",
        "elementType": "labels.text",
        "stylers": [
            {
                "weight": "0.01"
            }
        ]
    },
    {
        "featureType": "administrative.country",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#1eaf9b"
            },
            {
                "weight": "1"
            }
        ]
    },
    {
        "featureType": "administrative.country",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            },
            {
                "weight": "2"
            }
        ]
    },
    {
        "featureType": "administrative.country",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "administrative.locality",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#000000"
            },
            {
                "lightness": "0"
            }
        ]
    },
    {
        "featureType": "administrative.locality",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f2f2f2"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#39a9c9"
            },
            {
                "visibility": "on"
            }
        ]
    }
];

function LocationsMap({ locations, currentLocation, handleLocationSelection, currentLanguage }) {
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        // googleMapsApiKey: "AIzaSyCVJ5VQgwGbwhe3fpv_yhInVvj_hzjdqPs"
        googleMapsApiKey: "AIzaSyCxTS1yLBYBj_etlvK5NcFu5qnLJWuqqiU",
        language: currentLanguage
    })

    // eslint-disable-next-line
    const [map, setMap] = React.useState(null)

    const onLoad = React.useCallback(function callback(map) {
        // const bounds = new window.google.maps.LatLngBounds();
        // map.fitBounds(bounds);
        setMap(map);
    }, [])

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])

    const markerClicked = function(event, location) {
        handleLocationSelection(location);
    }

    function mapPanToMarker(map, location) {
        map.panTo(location.coordinates);
    }

    React.useEffect(() => {
        if (map && currentLocation) {
            mapPanToMarker(map, currentLocation);
        } else if (map) {
            map.panTo(center);
        }
    }, [map, currentLocation]);

    const renderMap = () => {
        return <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={6}
            onLoad={onLoad}
            onUnmount={onUnmount}
            options={{
                styles: stylesArray
            }}
        >
            {locations.map((location) => (
                <Marker
                    key={location.id}
                    id={location.id}
                    position={location.coordinates}
                    title={location.name}
                    onClick={(e) => markerClicked(e, location)}
                />
            ))}
        </GoogleMap>
    }

    return isLoaded ? renderMap() : <LoadingIndicator />
}

export default React.memo(LocationsMap)